import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  TARIFF_CI_CO,
  TARIFF_DISCOUNT,
  TARIFF_INTEREST,
  TARIFF_IRREGULAR_QUOTAS,
  TARIFF_LEASING,
} from '@app/@core/constants/routes.constants';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TariffGuard } from './tariffs.guard';

const routes: Routes = [
  {
    path: TARIFF_LEASING,
    loadChildren: () => import('./leasing/leasing.module').then((m) => m.LeasingModule),
    data: { title: marker('sidenav.menu.tariffSheet.leasing') },
    canActivate: [TariffGuard],
  },
  {
    path: TARIFF_DISCOUNT,
    loadChildren: () => import('./discount/discount.module').then((m) => m.DiscountModule),
    data: { title: marker('sidenav.menu.tariffSheet.discount') },
    canActivate: [TariffGuard],
  },
  {
    path: TARIFF_INTEREST,
    loadChildren: () => import('./interest/interest.module').then((m) => m.InterestModule),
    data: { title: marker('sidenav.menu.tariffSheet.interest') },
    canActivate: [TariffGuard],
  },
  {
    path: TARIFF_CI_CO,
    loadChildren: () => import('./ci-co/ci-co.module').then((m) => m.CiCoModule),
    data: { title: marker('sidenav.menu.tariffSheet.ciCo') },
    canActivate: [TariffGuard],
  },
  {
    path: TARIFF_IRREGULAR_QUOTAS,
    loadChildren: () => import('./irregular-quotas/irregular-quotas.module').then((m) => m.IrregularQuotasModule),
    data: { title: marker('sidenav.menu.tariffSheet.irregularQuota') },
    canActivate: [TariffGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TariffsRoutingModule {}
